import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDeviationAPI } from "../../Redux/App/app.actions";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Code,
  Flex,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { formatDate } from "../utils/utils";
import { useNavigate } from "react-router-dom";

const DeviationHistory = () => {
  const state = useSelector((state) => state.app);
  let past_deviations = state.past_deviations;
  const dispatch = useDispatch();

  const navigate = useNavigate("/");
  const getRowColor = (recommended, actual) => {
    if (recommended < actual) {
      return "green";
    }
    if (recommended == actual) {
      return "black";
    }
    return "red";
  };

  useEffect(() => {
    dispatch(getDeviationAPI());
  }, []);

  if (past_deviations?.isLoading) {
    return (
      <Text fontSize="20px" fontWeight="600">
        Loading...
      </Text>
    );
  }

  if (past_deviations?.data?.length) {
    return (
      <>
        <TableContainer w="100%">
          <Table>
            <Thead position="sticky" top="0" zIndex="sticky" bg="white">
              <Tr>
                <Th textAlign="left">Sr.No</Th>
                <Th textAlign="left">Deviation Date</Th>
                <Th textAlign="left">Burden sheet date</Th>
                <Th textAlign="left">Burden sheet id</Th>
              </Tr>
            </Thead>
          </Table>
        </TableContainer>
        <Accordion allowMultiple allowToggle>
          {past_deviations?.data?.length > 0 &&
            past_deviations.data
              .filter((el) => el.burden_sheet_id)
              .reverse()
              .map((elem, idx) => (
                <AccordionItem key={elem._id}>
                  <AccordionButton>
                    <TableContainer w="100%">
                      <Table>
                        <Tbody>
                          <Tr>
                            <Td>{idx + 1}</Td>
                            <Td>{formatDate(elem.created_on)}</Td>
                            <Td>{formatDate(elem.burden_sheet_date)}</Td>
                            <Td>{elem.burden_sheet_id}</Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </TableContainer>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel pb={4}>
                    <TableContainer>
                      {elem.start_date && elem.end_date && (
                        <Flex>
                          <Code
                            fontWeight="bold"
                            fontSize="15px"
                            p="5px"
                            children={`Start date : ${formatDate(
                              elem.start_date
                            )}`}
                          />
                          <Code
                            fontWeight="bold"
                            ml="20px"
                            p="5px"
                            children={`End date : ${formatDate(elem.end_date)}`}
                          />
                        </Flex>
                      )}
                      {elem.data.filter(
                        (el) =>
                          el["Actual added"] != el["Value in burden sheet"]
                      ).length > 0 && (
                        <Table size="sm" mt="1rem">
                          <Thead>
                            <Tr>
                              <Th>Lot no.</Th>
                              <Th>Type</Th>
                              <Th>Value in burden sheet</Th>
                              <Th>Actually added</Th>
                              <Th>Deviation</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {elem.data
                              .filter(
                                (el) =>
                                  el["Actual added"] !=
                                  el["Value in burden sheet"]
                              )
                              .map((elem, idx) => (
                                <Tr
                                  key={idx}
                                  m="0"
                                  p="0"
                                  bg={
                                    elem["Actual added"] !=
                                    elem["Value in burden sheet"]
                                      ? "orange.200"
                                      : "white"
                                  }
                                >
                                  <Td>{elem["Lot no."]}</Td>
                                  <Td>{elem["Type"]}</Td>
                                  <Td>{elem["Value in burden sheet"]}</Td>
                                  <Td>{elem["Actual added"]}</Td>
                                  <Td fontSize="15px">
                                    {elem["Actual added"] -
                                      elem["Value in burden sheet"]}
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      )}
                    </TableContainer>
                  </AccordionPanel>
                </AccordionItem>
              ))}
        </Accordion>
      </>
    );
  }

  return (
    <Box>
      <Box textAlign="center" py={10} px={6}>
        <Heading
          display="inline-block"
          as="h2"
          size="xl"
          bgGradient="linear(to-r, #15112e, #372c78)"
          backgroundClip="text"
        >
          No Past Deviations
        </Heading>
        {/* <Text color={"gray.500"} mb={6}>
          Click on the below button to create a new deviation
        </Text>
        <Button
          onClick={() => navigate("/deviation")}
          colorScheme="teal"
          _hover={{ bgGradient: "linear(to-r, #15112e, #372c78)" }}
          bgGradient="linear(to-r, #15112e, #372c78)"
          color="white"
          variant="solid"
        >
          create
        </Button> */}
      </Box>
    </Box>
  );
};

export default DeviationHistory;
